const validation = {
  number: {
    required: {
      message: 'Please enter either a building number or a building name',
      alternative: 'buildingname',
    },
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your building number',
    },
  },
  buildingname: {
    required: {
      message: 'Please enter either a building number or a building name',
      alternative: 'number',
    },
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your building name',
    },
  },
  organisation: {
    required: false,
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your organisation',
    },
  },
  subbuildingname: {
    required: false,
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your flat number',
    },
  },
  street: {
    required: { message: 'Please enter your street' },
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your street',
    },
  },
  posttown: {
    required: { message: 'Please enter your town or city' },
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your town or city',
    },
  },
  postcode: {
    required: { message: 'Please enter your postcode' },
    pattern: {
      value: /^[a-zA-Z][a-zA-Z]?[0-9]([a-zA-Z]|[0-9])? ?[0-9][a-zA-Z]{2}$/,
      message: 'Please enter a valid postcode e.g SW1A 1AA',
    },
  },
  country: {
    required: { message: 'Please enter your country' },
    pattern: {
      value: /^[a-zA-Z0-9 '\-,.]+$/,
      message: 'Please use only letters, numbers or spaces when entering your country',
    },
  },
}

export const getAddressErrors = (address, customValidation = validation) => {
  const errors = {}

  for (const [field, validationRules] of Object.entries(customValidation)) {
    const required =
      validationRules.required && !address[field] && !address[validationRules.required.alternative]
    if (required) {
      errors[field] = validationRules.required.message
      continue
    }
    if (!required && !address[field]) {
      continue
    }
    if (validationRules.pattern && !validationRules.pattern.value.test(address[field])) {
      errors[field] = validationRules.pattern.message
    }
  }

  return errors
}

export const addressFieldNames = [
  'summaryline',
  'organisation',
  'number',
  'buildingname',
  'postcode',
  'street',
  'posttown',
  'udprn',
  'uprn',
  'country',
]

export const addressEditFields = [
  {
    name: 'organisation',
    label: 'Organisation',
  },
  {
    name: 'number',
    label: 'Building number',
  },
  {
    name: 'buildingname',
    label: 'Building name',
  },
  {
    name: 'subbuildingname',
    label: 'Flat number',
  },
  {
    name: 'street',
    label: 'Street',
  },
  {
    name: 'posttown',
    label: 'Town or city',
  },
  {
    name: 'postcode',
    label: 'Postcode',
  },
  {
    name: 'country',
    label: 'Country',
  },
]
